import AWS from "aws-sdk";
AWS.config.region = "us-east-1"; // Region
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: process.env.VUE_APP_S3ID
});

export default class BuildingLayout {
  constructor() {
    this.urlBase = 'https://s3-ap-southeast-1.amazonaws.com/top-agent-macau-building-layouts'
    this.s3 = new AWS.S3({
      apiVersion: "2006-03-01",
      params: {
        Bucket: "top-agent-macau-building-layouts"
      }
    });
    this.getLayoutImages('hello').catch(e => null);
  }
  async getLayoutImages(name) {
    return new Promise((res, rej) => {
      if (!name) {
        return rej("!name");
      }
      this.s3.listObjects({ Delimiter: "/", Prefix: `${name}/` }, (err, data) => {
        if (err) {
          rej(err);
        } else {
          const reg = new RegExp(`^${name}/(.*).(jpg|png)$`);
          const images = data.Contents
            .filter(c => c.Size)
            .map(c => ({
              src: `${this.urlBase}/${c.Key}`,
              thumbSrc: `${this.urlBase}/${c.Key}`,
              w: 1600,
              h: 1600,
              title: c.Key.replace(reg, '$1'),
            }))
          res(images);
        }
      });
    });
  }
}